//Hooks
import { get } from 'svelte/store';
//Helpers
import {
	real_id,
	isProThreeEM,
	isPill,
	isShellyPresence,
	isEMWithoutSwitch,
} from 'src/helpers/interface_helpers';
import { isPeripheralDevice } from '../../../addons/addon_device_helpers';
import {
	getComponentIdByDeviceChannel,
	isCombinationDeviceLightMode,
} from '../core/local_action_components_helpers';
// Stores
import { devices_status } from 'src/stores/device-runtime/status';
import { devices } from 'src/stores/lists/devices';
import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';
//Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const doesSupportLocalActions = (device: Device): boolean => {
	if (isVirtualDevice(device.type) || isPeripheralDevice(device.type)) {
		//Check if the main device supports Local Actions.
		device = get(devices)[real_id(device.id)];
		if (!device) return false;
	}
	// EM devices without switch/relay should not support local actions
	if (isEMWithoutSwitch(device.type)) {
		return false;
	}
	let hasLocalActions = !/^(sensor|power_meter|inputs_reader|thermostat|gateway)$/.test(
		device.category,
	);
	if (isProThreeEM(device.type)) {
		const status = devices_status.getByRealId(device.id);
		if (!status?.['switch:100']) hasLocalActions = false;
	}
	return (
		isPill(device.type) ||
		isShellyPresence(device.type) ||
		/^(SBTR-001AEU|SHTRV-01|S3XT-0S|S3PL-30116EU)$/.test(device.type) ||
		hasLocalActions
	);
};

export const isSupportedMethodByChannel = (
	device: Device,
	job: ActionJob,
	deviceChannel: number,
): boolean => {
	if (!isCombinationDeviceLightMode(device)) {
		return job?.params?.id == deviceChannel;
	}
	deviceChannel = getComponentIdByDeviceChannel(device);
	const method = (job?.method || '').toLowerCase();
	return job?.params?.id == deviceChannel && RegExp(`^${device.mode}\.`).test(method);
};
